// import React from 'react'; // , useContext
import { Link } from 'react-router-dom';
// import DisplayNewsletterForm from '../../components/DisplayNewsletterForm';

const Maud   = () => {

 
  return (
    <div id="courses">
      <div id="title">
        <h1>Admin pour Maud</h1>
      </div>
      <div id="content">
        <Link className="button" to="/admin-team">Gérer l'équipe</Link>
        <Link className="button" to="/admin-photos">Gérer les photos</Link>
        <Link className="button" to="/admin-stages">Gérer les stages</Link>
        {/* <Link className="button" to="/admin-inscriptions">Gérer les inscriptions</Link>   */}
          {/* <DisplayNewsletterForm /> */}
      </div>
    </div>
  )
};

export default Maud;
